import { PaymentElement } from "@stripe/react-stripe-js";
import { useState } from "react";
import { useStripe, useElements } from "@stripe/react-stripe-js";
import { Link } from "react-router-dom";
import {Form} from 'react-bootstrap';
export default function CheckoutForm({outOfStock,selecteAddId,clientSecret, stripePaymentData}) {
  const [validated, setValidated] = useState(false);
  const stripe = useStripe();
  const elements = useElements();
  const [isProcessing, setIsProcessing] = useState(false);
  const [errMsg, setErrMsg] = useState({});
  const handleSubmit = async (event) => {
    setErrMsg({})
    event.preventDefault();
    const form = event.currentTarget;
    if (!stripe || !elements) {
      // Stripe.js has not yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }

    if (form.checkValidity() === false) {
      event.stopPropagation();
    }
    setValidated(true);
    if(form.checkValidity()===true) {
       if(outOfStock!==0){
        alert('Please check few items are unavailable for checkout!');
        return false;
      }
     
      if(selecteAddId===null || selecteAddId===0 || selecteAddId===''){
        alert('Please save or select delivery address!');
        return false;
      }

      setIsProcessing(true);
      const queryString = new URLSearchParams(stripePaymentData).toString();
      const { error } = await stripe.confirmPayment({
        elements,
        confirmParams: {
          // Make sure to change this to your payment completion page
          return_url: `${window.location.origin}/payment-success?query=1&${queryString}`,
        },
      });
  
      if (error.type === "card_error" || error.type === "validation_error") {
        setErrMsg({cls:'alert alert-danger', msg:error.message});
      } else {
        setErrMsg({cls:'alert alert-danger text-center', msg:"An unexpected error occured."});
      }
      setIsProcessing(false);
    }
    
  };

  return (
    <Form noValidate validated={validated} onSubmit={handleSubmit}>
      <PaymentElement id="payment-element" />
      <div className="placeorder-btn">
        <div className="term-condition">
          <div className="form-check">
            <input required name="agreement" type="checkbox" className="form-check-input" />
            <label className="form-check-label">I agree with </label>
            <Link target="_blank" to={"/pages/shipping-information"}> Shipping Policy</Link>, <Link target="_blank" to="/pages/returns-exchanges-and-cancellations">Returns, Exchanges & Cancellations</Link> and <Link target="_blank" to="/pages/terms-conditions">Terms & Conditions</Link>
            {/* <div className="invalid-feedback">You must agree before submitting.</div> */}
          </div>

        </div>
        {/* Show any error or success messages */}
        {errMsg.cls? <div className={errMsg.cls}>{errMsg.msg}</div>:'' }
        <div className="checkoutbtn"><button disabled={isProcessing || !stripe || !elements} type="submit" className="button alt"> {isProcessing ? "Processing ... " : "Place order"}</button></div>        
        <div className="checkoutbtn"><Link to="/">Continue Shopping</Link></div>
      </div>
    </Form>
  );
}
